const EventStatuses = {
    PUBLISHED: {
        id: 'PUBLISHED',
        label: 'Published',
    },
    REGISTRATION_OPEN: {
        id: 'REGISTRATION_OPEN',
        label: 'Registration open',
    },
    REGISTRATION_ENDED: {
        id: 'REGISTRATION_ENDED',
        label: 'Registration ended',
    },
    WEEK_OF_EVENT: {
        id: 'WEEK_OF_EVENT',
        label: 'Week of event',
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS',
        label: 'In progress',
    },
    FINISHED: {
        id: 'FINISHED',
        label: 'Finished',
    },
}

module.exports = EventStatuses
